import { RouteComponentProps } from "@reach/router";
import { CountryCode } from "libphonenumber-js";
import React from "react";
import { Address, Client } from "../../../generated/graphql";
/* import { CountryProps } from "types"; */
/* import { Address, Client, Course, Individualsclient } from "__generated__/GraphQLTypes"; */

export enum CourseTypes {
  ENTREPRISE = "entreprise",
  PRIVATE_INDIVIDUAL = "individual",
}

export interface ICourseClientInfo {
  clientType?: CourseTypes;
  entreprise?: Client | any;
  individual?: IIndividualClient | any;
  entrepriseName?: string;
}

export interface Iproduct {
  code: string;
  name: string;
  quantity?: number;
}

export interface ICoursePickup {
  id: string;
  reference?: string;
  delay?: string;
  products?: Iproduct[];
  address: Address | any;
}

export interface ICourseDelivery {
  id: string;
  reference?: string;
  delay?: string;
  products?: Iproduct[];
  pickupAddress: Address | any;
  deliveryAddress: Address | any;
}
export interface IIndividualClient {
  firstname?: string;
  lastname?: string;
  phoneNumber?: string;
  secondPhoneNumber?: string;
  address?: Address;
  email?: string;
}

export interface ICourseForm {
  isLoading?: boolean;
  isSubmited?: boolean;
  clientInfo?: ICourseClientInfo;
  currentElement?: number;
  pickups?: ICoursePickup[];
  deliveries?: ICourseDelivery[];
}
export interface IAccordion {
  label?: string | React.ReactNode;
  children?: React.ReactNode;
  index?: number;
  currentElement?: number;
  isValid?: boolean;
  handleClick: (index?: number) => void;
}

export interface IRadionButton {
  label?: string;
  value: any;
  icon?: any;
  onChange: () => void;
  isChecked?: boolean;
  disabled?: boolean;
}

export interface ClientInfoStep {
  handleClick: (index?: number) => void;
}

export type IPickup = {
  pickupIndex: number;
  isEdit?: boolean;
};
export type IDelivery = {
  deliveryIndex: number;
  isEdit?: boolean;
};

export enum modalType {
  PICKUP_MODAL = "PICKUP_MODAL",
  DELIVERY_MODAL = "DELIVERY_MODAL",
}
export interface CountryProps {
  countryCodes?: CountryCode[];
}

export interface ICourseModal extends RouteComponentProps, CountryProps {
  onClose(): void;
  onConfirm?(): void;
  open: boolean;
  itemIndex?: string | number;
  modalType?: modalType;
  isPickup?: boolean;
}

export interface IDivider {
  prefix?: string;
}
export interface confirmCourseProps {
  onClose(): void;
  onConfirm?(): void;
  open: boolean;
  loading?: boolean;
  isEdit: boolean;
}

export interface IFooter {
  handleCreation(): void;
  handleCancelCreation?(): void;
  isEdit: boolean;
  isLoading?: boolean;
}
